export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.entry-16cbc5e98ece40705713.worker.js");
}
